const ResponseCodes = Object.freeze({
  EMAIL_EXISTS: 1,
  PASSWORD_INCORRECT: 2,
  USER_NOT_EXISTS: 3,
  NOT_ALLOW_TO_LOGIN: 4
});

export default (ResponseCodes);
